define('views/savings/saving_detail',[
    'views/_base/baseview',
    'text!views/savings/saving_detail.html',
    'views/savings/edit',
    'views/savings/manage',
    'views/shared/modal/modal_modern',
	'views/transactions/transaction',
	'models/accounts/accounttransaction_collection',
	'models/accounts/accounttransactiondata',
	'models/accounts/accounttransaction',
	'models/accounts/accounts'
], function (BaseView, Template, EditView, ManageAccountsView, Modal, AccountTransactionView, AccountTransactionCollection, AccountTransactionDataModel, AccountTransactionModel, AccountsModel){
    'use strict';

    return BaseView.extend({
        id       : 'saving-detail-container',
        tagName  : 'div',
        isRender : false,
        template : _.template(Template),
        events   : {
            'click .js-saving-detail-edit': 'showEditModal',
            'click .js-saving-detail-edit-allocation': 'manageAccountsModal',
            'click .js-manage-savings-allocations': 'manageAccountsModal',
			'click .js-saving-view-transactions-btn': 'goToTransactions',
			'click #back-to-previous': 'backToPrevious'
        },
        initialize: function(options){
            options = options || {};

            this.account_id = options.account_id;
			
			// transaction config
			this.last_days_count = 7;
			this.collection_transaction_list = new AccountTransactionCollection();
			
			this.show_button = true;

            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
			
			this.lookupRouteHistory();

            this.$el.html(this.template({ show_button: this.show_button }));

            return this;
        },

        loadData: function(){
            var that = this;

            pf.controller.loadAccounts(function(accounts){
                that.showAccount();
				that.getRecentTransactions(that.account_id);
            });

        },

        lookupRouteHistory: function(){

            if(pf.routeHistory.length >= 2){
                var route_name = pf.routeHistory[pf.routeHistory.length - 2].name;
                
                if(route_name == "showSavings" || route_name == "showRoot"){
                    this.show_button = true;
                }
                
            }

        },

        showAccount: function(){
            var that = this,
                account = pf.accounts.savings.filter(function(el){ return el.account_id == that.account_id });

            this.data = account[0];
            
            if(this.data){

                // if(this.data.target_amount != 0 && !isNaN(this.data.target_amount)){
                //     this.funded_amount = Math.round((this.data.balance / this.data.target_amount) * 100);
                // }

                this.render();

                if(this.data.is_editable == 1){
                    this.showEditButton();
                }
            }

        },

        showEditButton: function(){
            this.$('.js-saving-detail-edit').css({ display: 'inline' });
        },
		
		getRecentTransactions: function(account_id){
			
			var that = this;
		
			var ed = new Date();
			var sd = new Date();
	
			sd.setDate(sd.getDate() - that.last_days_count);
		
			var startdate = (sd.getMonth() + 1) + '/' + sd.getDate() + '/' + sd.getFullYear();
			var enddate = (ed.getMonth() + 1) + '/' + ed.getDate() + '/' + ed.getFullYear();
	
			var date_string = "&startdate=" + startdate + "&enddate=" + enddate;
		
			var account_transaction_data_model = new AccountTransactionDataModel();
		
			account_transaction_data_model.fetch({
				url: pf.consumerURL + "/Accounts/TX/" + account_id + "?pn=1" + date_string +"&periodType=2" 
			}).done(function (response) {
				that.collection_transaction_list = account_transaction_data_model.attributes.transaction_list;
				that.$(".loading-transactions").remove();
				that.showRecentTransactions();
				that.addAllTransactions();
			
			}).fail(function (err) {
				// console.error(err);
			});
			
		},
		
		addAllTransactions: function(){
			var that = this;
			
			if(that.collection_transaction_list && that.collection_transaction_list.length > 0) {
				that.collection_transaction_list.length = 5;
				that.collection_transaction_list.forEach(that.addOneTransaction, that);
			} else {
				// show empty state
				that.showTransactionsEmptyState();
			}
		},
		
		addOneTransaction: function (account_transaction) {
			var transaction = new AccountTransactionModel(account_transaction);
			var transaction_view = new AccountTransactionView({ model: transaction });
			this.$(".js-saving-recent-transactions").append(transaction_view.el);
		},

        showTransactionsEmptyState: function(){
            this.$el.find('.js-saving-recent-transactions-empty').show();
			// this.$el.find('.js-saving-view-transactions-btn').hide();
        },

        showRecentTransactions: function(){
            this.$el.find('.js-saving-recent-transactions').show();
            this.$el.find('.js-saving-view-transactions-btn').css({ display: 'block' });
        },

        manageAccountsModal: function(){
            var manage_savings_view_modal = new ManageAccountsView();
                
            var manage_savings_modal = new Modal({
                show        : true,
                content     : manage_savings_view_modal.$el.html(),
                calling_view: manage_savings_view_modal
            });
        },

        showEditModal: function(){
            var savings_edit_view_modal = new EditView({ data: this.data });
                
            var savings_edit_modal = new Modal({
                show        : true,
                content     : savings_edit_view_modal.$el.html(),
                calling_view: savings_edit_view_modal,
                parent_view : this
            });
        },
		
		goToTransactions: function (e) {
			e.preventDefault();
			pf.navigate('transactions/' + this.account_id);
		},
		
		backToPrevious: function (e) {
			e.preventDefault();
			history.go(-1);
		},
		
        close: function(){}
    });
});

